export { default as VendorStickyFooter } from './VendorStickyFooter';
